module.exports = __webpack_public_path__ + "static/img/topbg-off.1bbb1d2a.png";